module.exports = __webpack_public_path__ + "static/img/img_case.2c8f149a.png";